import type { IntegrationTag } from "./generated/integrationTag";

import { z } from "zod";

export const integrationTagSchema = z
  .enum([
    "design-creative",
    "dam-assets",
    "accessibility",
    "email-sms",
    "ad-platforms",
    "social-media",
    "content-cms",
    "affiliates-influencers",
    "aeo-seo",
    "upsell-cross-sell",
    "ab-testing",
    "forms",
    "merchandising",
    "reviews",
    "ux-heatmaps",
    "subscriptions",
    "support",
    "crm",
    "loyalty-referral",
    "returns",
    "post-purchase-order-tracking",
    "analytics-data",
    "commerce-payments",
    "operations",
    "shipping-fulfillment",
    "fraud-risk",
    "inventory",
    "translation-localization",
    "privacy-legal",
    "business-finance",
    "tax-compliance",
    "research",
    "mcp-connectors",
  ])
  .describe("IntegrationTag");

export const INTEGRATION_TAG_DISPLAY_NAMES: Record<IntegrationTag, string> = {
  "design-creative": "Design / Creative",
  "dam-assets": "DAM / Assets",
  accessibility: "Accessibility",
  "email-sms": "Email / SMS",
  "ad-platforms": "Ad Platforms",
  "social-media": "Social Media",
  "content-cms": "Content / CMS",
  "affiliates-influencers": "Affiliates / Influencers",
  "aeo-seo": "AEO / SEO",
  "upsell-cross-sell": "Upsell / Cross-sell",
  "ab-testing": "A/B Testing",
  forms: "Forms",
  merchandising: "Merchandising",
  reviews: "Reviews",
  "ux-heatmaps": "UX / Heatmaps",
  subscriptions: "Subscriptions",
  support: "Support",
  crm: "CRM",
  "loyalty-referral": "Loyalty / Referral",
  returns: "Returns",
  "post-purchase-order-tracking": "Post-purchase / Order Tracking",
  "analytics-data": "Analytics / Data",
  "commerce-payments": "Commerce / Payments",
  operations: "Operations",
  "shipping-fulfillment": "Shipping / Fulfillment",
  "fraud-risk": "Fraud / Risk",
  inventory: "Inventory",
  "translation-localization": "Translation / Localization",
  "privacy-legal": "Privacy / Legal",
  "business-finance": "Business / Finance",
  "tax-compliance": "Tax Compliance",
  research: "Research",
  "mcp-connectors": "MCP Connectors",
};
